import { collection, addDoc, query, where, getDocs, documentId, doc, updateDoc } from "firebase/firestore";
import { getUsersByUID } from './userService'
import { db } from '../firebase';

async function createLeague(league) {

    return new Promise((resolve, reject) => {
        addDoc(collection(db, "leagues"), league)
        .then((l) => {
            resolve(l);
        }).catch((e) => reject(e));
    });

}

async function updateLeague(league) {

    return new Promise((resolve, reject) => {
        updateDoc(doc(db, "leagues", league.lid), league)
        .then((l) => { 
            console.log("updateLeague", l, league)
            resolve(league); 
        })
        .catch((e) => reject(e));
    });

}

/*
async function updateLeague(league) {
    console.log("updateLeague", league)

    const q = query(collection(db, "leagues"), where("_id", "==", league.lid));
    const querySnapshot = await getDocs(q);
    let docid = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(docid)) {
            docid = doc.id
        } else {
            err = 'Multiple leagues found with the same _id';
        }
    });    

    console.log("docid", docid)

    return new Promise((resolve, reject) => {
        if(err) { reject(err) }
        const docRef = doc(db, "leagues", docid);
        setDoc(docRef, league, { merge: true})
        .then(() => resolve(league))
        .catch((e) => reject(e));
    });
}
*/

async function getLeaguesByUID(uid) {
    try {
        let leagues = [];
        
        // Query leagues where the user is part of the "players" array
        const q = query(collection(db, "leagues"), where("players", "array-contains", uid));
        const querySnapshot = await getDocs(q);

        // Extract league data
        querySnapshot.forEach((doc) => {
            const league = doc.data();
            league.id = doc.id;
            leagues.push(league);
        });

        // Collect unique player UIDs
        const playersToDownload = Array.from(
            new Set(leagues.flatMap((league) => league.players))
        );

        if(playersToDownload.length === 0) {
            playersToDownload.push(uid)
        }

        // Fetch user data for all unique player UIDs
        const userObjects = await getUsersByUID(playersToDownload);

        // Replace player UIDs with user objects in leagues
        const enrichedLeagues = leagues.map((league) => ({
            ...league,
            players: league.players.map(
                (uid) => userObjects.find((user) => user.uid === uid) || uid // Fallback to UID if user object not found
            ),
        }));

        return enrichedLeagues; // Resolve the enriched leagues
    } catch (error) {
        console.error("Error fetching leagues or players:", error);
        throw error; // Reject with the error
    }
}

async function getLeagueByLID(lid) {
    
    const q = query(collection(db, "leagues"), where(documentId(), '==', lid));

    const querySnapshot = await getDocs(q);
    let l = null, err = null;
    querySnapshot.forEach((doc) => {
        if(!Boolean(l)) {
            l = doc.data();
        } else {
            err = 'Multiple leagues found with the same lID';
        }
    });

    return new Promise((resolve, reject) => {
        if(Boolean(err)) { reject(err); } // error, e.g. multiple users found
        else if(!Boolean(l)) { resolve(null); }  // ok, but no user found
        else { resolve(l); } // ok, return league
    });
}

async function searchLeagues(searchText) {
    if (!searchText || searchText.length < 3) return [];
    
    try {
        const leaguesRef = collection(db, "leagues");
        const q = query(
            leaguesRef,
            where("name_lower", ">=", searchText.toLowerCase()),
            where("name_lower", "<=", searchText.toLowerCase() + '\uf8ff')
        );
        
        const querySnapshot = await getDocs(q);
        const results = [];
        
        querySnapshot.forEach((doc) => {
            const league = doc.data();
            results.push({
                id: doc.id,
                name: league.name,
                isLocked: league.isLocked,
                logoURL: league.logoURL,
                createdBy: league.createdBy
            });
        });
        
        return results;
    } catch (error) {
        console.error("Error searching leagues:", error);
        return [];
    }
}




/*
async function getLeaguesByUID(uid) {

    let ls = [], err = null;
    const q = query(collection(db, "leagues"), where("players", "array-contains", uid))
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        let l = doc.data()
        l.id = doc.id
        ls.push(l)
    });

    let playersToDownload = []
    ls.forEach((l) => {
        l.players.forEach((p) => {
            if(!playersToDownload.includes(p)) {
                playersToDownload.push(p)
            }
        })
    })

    getUsersByUID(playersToDownload).then((ptd) => {
        let newls = []
        ls.forEach((l) => { // loop through leagues to replace uid by user objects
            let newplayers = []
            l.players.forEach((p) => {
                if(ptd.filter((pt) => pt.uid === p).length === 1){
                    newplayers.push(ptd.filter((pt) => pt.uid === p)[0])
                }
            })
            l.players = newplayers;
            newls.push(l)
            console.log("ls2", newls)
        })

        console.log("ls3", newls)

        return new Promise((resolve, reject) => {
            if(Boolean(err)) { reject(err); } // error
            else { resolve(newls); } // ok, return leagues
        });
    }).catch((e) => console.log("error", e))
}
    */

/*
async function getRankedListForLID(lid) {

    let rl = [], err = null;
   
    return new Promise((resolve, reject) => {
        if(Boolean(err)) { reject(err); } // error
        else { resolve(rl); } // ok, return leagues
    });

}*/

export {
    createLeague,
    getLeagueByLID,
    getLeaguesByUID,
    searchLeagues,
    updateLeague
    //getRankedListForLID
}